/**
 * Get background from `data-lazy-background` attribute and set it as background.
 * @param {jQuery} $slide
 */
function convertToBackgroundImage($slide) {
    const $bg = $slide.data('lazy-background') ? $slide : $slide.find('[data-lazy-background]');

    const imageSource = $bg.data('lazy-background');

    if (imageSource) {
        $slide.css('background-image', `url("${imageSource}")`);
    }

    $bg.removeAttr('data-lazy-background');
}

/**
 * Apply lazy load background.
 * @param {jQuery} $slickSlider
 */
export default function lazyBackground($slickSlider) {
    $slickSlider.on('init', (event, slick) => {
        const $currentShown = $(slick.$slides.get(slick.currentSlide));

        convertToBackgroundImage($currentShown);
    }).on('beforeChange', (event, slick, currentSlide, nextSlide) => {
        const $nextSlide = $(slick.$slides.get(nextSlide));

        convertToBackgroundImage($nextSlide);
    });
}



// WEBPACK FOOTER //
// ./src/js/components/ui-c-slider/lazyBackground.js